import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { ModalDirective } from 'angular-bootstrap-md';

import { AppComponent } from 'src/app/app.component';
import { CommonService } from 'src/services/common/common.service';
import { HttpClient } from '@angular/common/http';
import { ServiceManagerService } from 'src/services/service-manager.service';
import { SocketService } from 'src/services/socket/socket.service';
import { LanguageList } from 'src/constants/constant';

@Component({
  selector: 'app-chat',
  templateUrl: './chat.component.html',
  styleUrls: ['./chat.component.scss'],
})
export class ChatComponent implements OnInit {
  domainUrl: string = '';
  feedbackExperience: any = '';
  isApiTriggered: any = false;
  isChatEnded: any = false;
  message: any = '';
  messageList: any = [];
  messageObj: any = {};
  currentFeedback: any;
  session: any = {};
  showChatSubscriber: any;
  endChatSubscriber: any;
  isChatEndedByPeer: any = false;
  showEmojiPicker: any = false;
  emojiListener: any;
  isFetchingMessages: any = false;
  Object = Object;
  showLanguage: any = false;
  selectedLanguage: any = LanguageList[localStorage.getItem('language') || 'en'];
  @ViewChild('chatTrigger') private chatTrigger: ElementRef | undefined;
  @ViewChild('chatModal') showChatModal: ModalDirective | undefined;
  @ViewChild('endChatModal') showEndChatModal: ModalDirective | undefined;
  @ViewChild('chat') private chatContainer: ElementRef;
  @ViewChild('langWrapper') private langWrapper: ElementRef | undefined;

  /**
   * Creates an instance of chat component.
   * @param app
   * @param commonService
   * @param datePipe
   * @param http
   * @param serviceManager
   * @param socketService
   */
  constructor(
    private app: AppComponent,
    public commonService: CommonService,
    public datePipe: DatePipe,
    private http: HttpClient,
    private serviceManager: ServiceManagerService,
    private socketService: SocketService
  ) {
    this.chatContainer = {} as ElementRef;
    if (!commonService.showChat.observed) {
      this.showChatSubscriber = commonService.showChat.subscribe(
        (data: any) => {
          if (data == 'reconnect' && this.showChatModal?.isShown) {
            this.getMessages();
          } else if (data != 'reconnect') {
            this.showChat();
          }
        }
      );
      commonService.chatScroll.subscribe((data: any) => {
        this.setChatProcess(false);
        this.scrollToBottom();
      });
      commonService.messageReceived.subscribe((data: any) => {
        var sendDate: any = new Date(data['message'].timestamp)
          .toLocaleString()
          .split(',');
        data['message'].time = sendDate[1];
        if (!this.messageObj[sendDate[0]]) {
          this.messageObj[sendDate[0]] = [];
        }
        this.messageObj[sendDate[0]].push(data['message']);
        this.scrollToBottom();
      });

      this.endChatSubscriber = commonService.chatEnded.subscribe(
        (data: any) => {
          if (data == 'home-chat-end') {
            this.isChatEnded = false;
          } else {
            this.commonService.current.page = 'HOME';
            this.commonService.current.status = 'INITIAL';
            commonService.current.page = 'HOME';
            this.isChatEndedByPeer = true;
            this.isChatEnded = true;
          }
          this.showEndChat();
        }
      );
    }
  }

  ngOnInit(): void {
    this.domainUrl = window.location.origin;
  }

  ngAfterViewInit(): void {
    this.showChatModal?.onShown.subscribe(() => {
      if (this.commonService.currentDevice != 'desktop')
        document.getElementById('message-input')?.focus();
      else document.getElementById('message-input-desk')?.focus();
    });
  }

  ngOnDestroy() {
    this.showChatSubscriber.unsubscribe();
    this.endChatSubscriber.unsubscribe();
  }

  /**
   * Closes chat
   */
  closeChat() {
    this.showEmojiPicker = false;
    if (this.showChatModal?.isShown) {
      this.showChatModal.hide();
    }
    this.commonService.unreadMessage = 0;
    this.app.modal.hide();
  }

  /**
   * Toggles the mobile chat header's language dropdown
   */
  toggleLanguage() {
    this.showLanguage = !this.showLanguage;
  }

  /**
   * Selects language from the mobile chat header dropdown
   * @param option
   */
  selectLanguage(option: any) {
    this.showLanguage = false;
    this.selectedLanguage = option;
    for (var language in LanguageList) {
      if (LanguageList[language] == option) {
        this.commonService.saveLanguage(language, '/home');
      }
    }
  }

  /**
   * Languages other than the currently selected one
   */
  availableLanguages() {
    return Object.values(LanguageList).filter(
      (option: any) => option != this.selectedLanguage
    );
  }

  /**
   * Closes the language dropdown when clicking outside it
   * @param event
   */
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (
      this.showLanguage &&
      this.langWrapper &&
      !this.langWrapper.nativeElement.contains(event.target)
    ) {
      this.showLanguage = false;
    }
  }

  /**
   * Shows end chat
   */
  showEndChat() {
    this.showEmojiPicker = false;
    this.closeChat();
    this.showEndChatModal?.show();
  }

  /**
   * Ends chat
   */
  endChat() {
    this.showEmojiPicker = false;
    this.feedbackExperience = '';
    var request = {
      session_id: this.commonService.peerDetails.sessionId,
    };
    this.serviceManager
      .CallBackendServiceAPI('chat_end', request)
      .subscribe((response: any) => {
        this.commonService.current.page = 'HOME';
        this.commonService.current.status = 'INITIAL';
        this.isChatEnded = true;
        this.socketService.endChat({
          id: this.commonService.peerDetails.peerId,
          sessionId: this.commonService.peerDetails.sessionId,
          message: 'Chat Ended',
        });
        localStorage.removeItem('chatProcess');
      });
  }

  /**
   * Adds emoji
   * @param event
   */
  addEmoji(event: any) {
    this.message += event.emoji.native;
  }

  /**
   * Listens click
   * @param e
   */
  listenClick(e: any) {
    if (
      !document.getElementById('emoji-container')?.contains(e?.target) &&
      !document.getElementById('emoji-btn')?.contains(e?.target)
    ) {
      this.hideEmoji();
    }
  }

  /**
   * Shows emoji container in chat
   */
  showEmoji() {
    this.showEmojiPicker = !this.showEmojiPicker;
    this.emojiListener = this.listenClick.bind(this);
    document
      .getElementById('chat-container')
      ?.addEventListener('click', this.emojiListener, true);
  }

  /**
   * Hides emoji container
   */
  hideEmoji() {
    document
      .getElementById('chat-container')
      ?.removeEventListener('click', this.emojiListener, true);
    this.showEmojiPicker = false;
  }

  async showChat() {
    // this.commonService.peerStatus = 'IDEAL';
    this.commonService.unreadMessage = 0;
    this.showEmojiPicker = false;
    if (!this.showChatModal?.isShown) {
      this.showChatModal?.show();
      this.commonService.isChatShowed = true;
    }
    await this.getMessages();
  }
  getMessages() {
    if (this.isFetchingMessages) return;
    this.isFetchingMessages = true;

    this.messageObj = {};
    this.messageList = [];
    var body = {
      session_id: this.commonService.peerDetails.sessionId,
    };

    this.serviceManager
      .CallBackendServiceAPI('get_conversation', body)
      .subscribe(
        (data: any) => {
          this.messageList = data['messageList'];
          this.messageList = this.messageList.sort((a: any, b: any) =>
            a.timestamp < b.timestamp ? -1 : 1
          );
          this.messageList.forEach((message: any) => {
            var sendDate: any = new Date(message.timestamp)
              .toLocaleString()
              .split(',');
            message.time = sendDate[1];
            if (!this.messageObj[sendDate[0]]) {
              this.messageObj[sendDate[0]] = [];
            }
            this.messageObj[sendDate[0]].push(message);
          });
          this.setChatProcess(true);
          this.scrollToBottomDefault();
          this.isFetchingMessages = false;
        },
        (error: any) => {
          console.log(error);
          this.isFetchingMessages = false;
        }
      );
  }

  /**
   * Sets chat process
   * @param isInitial
   */
  setChatProcess(isInitial: any) {
    var chatProcess = JSON.parse(localStorage.getItem('chatProcess') || '[]');
    chatProcess.forEach((e: any) => {
      if (!isInitial && e.isShowed) {
        return;
      }
      e.isShowed = true;
      if (!this.messageObj[e.date]) {
        this.messageObj[e.date] = [];
        this.messageObj[e.date].push(e);
      } else {
        var messageLength = this.messageObj[e.date].length || 0;
        var i = 0;
        for (; i < messageLength; i++) {
          if (this.messageObj[e.date][i].time > e.time) {
            break;
          }
        }
        this.messageObj[e.date].splice(i, 0, e);
      }
    });
    localStorage.setItem('chatProcess', JSON.stringify(chatProcess));
  }

  /**
   * Animates scroll
   * @param duration
   */
  animateScroll(duration: any) {
    var start = this.chatContainer.nativeElement.scrollTop;
    var end = this.chatContainer.nativeElement.scrollHeight;
    var change = end - start;
    var increment = 20;
    const easeInOut = (
      currentTime: any,
      start: any,
      change: any,
      duration: any
    ) => {
      // by Robert Penner
      currentTime /= duration / 2;
      if (currentTime < 1) {
        return (change / 2) * currentTime * currentTime + start;
      }
      currentTime -= 1;
      return (-change / 2) * (currentTime * (currentTime - 2) - 1) + start;
    };
    const animate = (elapsedTime: any) => {
      elapsedTime += increment;
      var position = easeInOut(elapsedTime, start, change, duration);
      this.chatContainer.nativeElement.scrollTop = position;
      if (elapsedTime < duration) {
        setTimeout(function () {
          animate(elapsedTime);
        }, increment);
      }
    };
    animate(0);
  }

  /**
   * Scrolls to bottom
   */
  scrollToBottom() {
    var duration = 300; // Or however many milliseconds you want to scroll to last
    this.animateScroll(duration);
  }

  /**
   * Scrolls to bottom default
   */
  scrollToBottomDefault() {
    this.chatContainer.nativeElement.scrollTop =
      this.chatContainer.nativeElement.scrollHeight;
  }

  /**
   * Sends message
   */
  sendMessage() {
    this.showEmojiPicker = false;
    if (!this.message) {
      return;
    }
    var body = {
      conversation_text: this.message,
      session_id: this.commonService.peerDetails.sessionId,
      user_id: localStorage.getItem('userId'),
    };
    this.serviceManager
      .CallBackendServiceAPI('set_conversation', body)
      .subscribe(
        (response: any) => {
          var message: any = response['data']['message'];
          this.socketService.sendMessage(message);
          var sendDate: any = new Date(message.timestamp)
            .toLocaleString()
            .split(',');
          message.time = sendDate[1];
          if (!this.messageObj[sendDate[0]]) {
            this.messageObj[sendDate[0]] = [];
          }
          this.messageObj[sendDate[0]].push(message);
          this.message = '';
        },
        (error: any) => {
          console.log(error);
        }
      );
  }

  /**
   * Sets feedback
   * @param item
   */
  setFeedback(item: any) {
    this.currentFeedback = item;
    this.isApiTriggered = false;
  }

  /**
   * Sends feed back to the Database
   */
  sendFeedBack() {
    this.isApiTriggered = true;
    var feedBackList = [
      {
        rating: 0,
        experience: 'Worse',
      },
      {
        rating: 2,
        experience: 'Same as before',
      },
      {
        rating: 5,
        experience: 'Better',
      },
      {
        rating: 8,
        experience: 'Great',
      },
    ];
    var body = {
      rating: feedBackList[this.currentFeedback]['rating'],
      experience: this.feedbackExperience,
      session_id: this.commonService.peerDetails.sessionId,
      user_id: localStorage.getItem('userId'),
      peer_id: this.commonService.peerDetails.peerId,
    };
    this.serviceManager.CallBackendServiceAPI('add_feedback', body).subscribe(
      (response: any) => {
        this.showChatModal?.hide();
        this.showEndChatModal?.hide();
        this.commonService.navigateToPage('/help-us');
      },
      (error: any) => {
        console.log(error);
      }
    );
  }
}
